import { useQuery } from "@tanstack/react-query";
import { notificationsApiClient } from "@/Service/Api/V1/ApiClients/NotificationsApiClient";
import { QueryKeys } from "@/Service/Api/V1/QueryKeys/QueryKeys";

export const useGetNotificationsUnreadCount = () => useQuery({
    ...QueryKeys.notifications.unreadCount,
    queryFn: async () => await notificationsApiClient.getUnreadNotificationsCount(),
});
